// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Supported values of `DocumentModelBuildMode`.
 */
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var DocumentModelBuildMode = {
  /**
   * A mode that builds a model assuming that documents all follow the same, fixed template layout (the same relative
   * positioning of fields between documents).
   */
  Template: "template",

  /**
   * A mode that uses a neural engine to extract fields, allowing for documents that have different visual appearances,
   * but that contain the same information.
   */
  Neural: "neural"
};